// extracted by mini-css-extract-plugin
export default {"label":"VORoltx4qjqP_se4RY0n","selected":"EoPUwM1TbQRXU8Nsmivj"};